import dayjs from 'dayjs';
import { useEffect, useMemo, useState } from 'react';
import Chart from 'react-apexcharts';
import Flatpickr from 'react-flatpickr';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { GraphIcon } from '../../../utils/SVGIcon';
import { ApiDBSalesServiceStatistics } from '../DashboardOperation';

function ContentHead({ handleOnChange, formData }) {
    return (
        <div className="w-full inline-flex md:flex justify-between items-center gap-1">
            <div className="flex items-center gap-x-1 xl:gap-x-2 w-[calc(100%_-_192px)]">
                <GraphIcon className="inline-block size-4 xl:size-6 min-w-max" />
                <h4 className="text-primary-700 text-sm 2xl:text-xs whitespace-nowrap">Services</h4>
            </div>
            <Flatpickr
                name="date"
                options={{ mode: 'range' }}
                value={[formData.dateStart, formData.dateEnd]}
                onChange={handleOnChange}
                className="block w-[160px] xl:w-[180px] 2xl:w-[158px] focus:outline-none text-primary-700 !text-xs xl:!text-sm 2xl:!text-xs !bg-[98%_0px] xl:!bg-[100%_1px] !bg-[length:15px] xl:!bg-[length:17px]"
            />
        </div>
    );
}
function ServiceSales() {
    const { setMessage } = useTemplate();
    const startDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD');
    const endDate = dayjs().add(1, 'day').format('YYYY-MM-DD');
    const [dbSalesServices, setDbSalesServices] = useState([]);
    const [formData, setFormData] = useState({
        dateStart: startDate,
        dateEnd: endDate
    });

    const handleOnChange = (e) => {
        if (e.length === 2) {
            setFormData({
                dateStart: dayjs(e[0]).format('YYYY-MM-DD') || '',
                dateEnd: dayjs(e[1]).format('YYYY-MM-DD') || ''
            });
        }
    };
    useEffect(() => {
        ApiDBSalesServiceStatistics(formData)
            .then(({ data: resData }) => {
                setDbSalesServices(resData);
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err?.message });
            });
    }, [formData, setMessage]);
    const serviceName = useMemo(() => {
        const data = [];
        if (dbSalesServices?.length > 0) {
            dbSalesServices?.forEach((item) => {
                data.push(item?.serviceName);
            });
        }
        return data;
    }, [dbSalesServices]);
    const pieOptions = {
        chart: {
            width: '100%',
            height: '470px',
            type: 'donut'
        },
        dataLabels: {
            enabled: false
        },
        labels: serviceName,

        legend: {
            show: true,
            position: 'bottom'
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '65%',
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            showAlways: false,
                            label: 'Total',
                            fontSize: '22px',
                            fontWeight: 600,
                            color: '#373d3f',
                            formatter(w) {
                                return w.globals.seriesTotals.reduce((a, b) => {
                                    return a + b;
                                }, 0);
                            }
                        },
                        value: {
                            show: true,
                            fontSize: '16px',
                            fontWeight: 600,
                            color: '#373d3f',
                            offsetY: 16,
                            formatter(val) {
                                return val;
                            }
                        }
                    }
                }
            }
        },
        stroke: {
            show: true
        },
        tooltip: {
            enabled: true,
            fillSeriesColor: false,
            style: {
                fontSize: '14px',
                fontFamily: 'Roboto'
            },
            y: {
                formatter(value) {
                    return value;
                }
            }
        },
        colors: [
            '#FB8500',
            '#2A9D8F',
            '#E76F51',
            '#219EBC',
            '#588157',
            '#0077B6',
            '#FB6F92',
            '#8338EC',
            '#FFBE0B',
            '#FFBE0B',
            '#4CC9F0',
            '#76C893',
            '#00BD69',
            '#758bfd',
            '#540d6e',
            '#f2542d',
            '#124e78',
            '#C620A4',
            '#a9927d',
            '#476FFF',
            '#E29273',
            '#FF3945',
            '#084ACF',
            '#17D5FF',
            '#6E0E0A',
            '#302B27',
            '#C38184',
            '#228AC5',
            '#0CA34D'
        ]
    };

    const series = useMemo(() => {
        const data = [];
        if (dbSalesServices?.length > 0) {
            dbSalesServices?.forEach((item) => {
                data.push(item?.quantity);
            });
        }
        return data;
    }, [dbSalesServices]);
    return (
        <div className="p-2 pb-4 md:px-3 lg:px-7 md:py-6 bg-white rounded-[25px] overflow-hidden shadow-[0px_0px_60px_0px_rgba(79,98,130,0.10)] ">
            <ContentHead handleOnChange={handleOnChange} formData={formData} />
            {dbSalesServices?.length === 0 ? (
                <div className="flex items-center justify-center h-64 md:h-44 lg:h-56 xl:h-72">
                    <h4 className="text-primary-700 text-base 2xl:text-xl">No Data Found</h4>
                </div>
            ) : (
                <div>
                    <Chart
                        width="100%"
                        heigh="100%"
                        options={pieOptions}
                        series={series}
                        type="donut"
                    />
                </div>
            )}
        </div>
    );
}

export default ServiceSales;
